import { AuthState } from './definitions';

export class AuthFactory
{
	public static buildState(): AuthState
	{
		return {
			tncUpdated: false,
			privacyPolicyUpdated: false,
			userId: '',
			firstName: '',
			lastName: '',
			adminEmailId: '',
			email: '',
			contactGRID: '',
			contactID: '',
			phoneNumber: '',
			roles: [
				''
			],
			customerIds: [
				'',
				''
			],
			locations: [],
			topLevelGrid: ''
			
		};
	};
}
